var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsentPending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 24 24",
    height: 22,
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      color: "rgb(255, 127, 62)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H6V8.83L10.83 4H18v16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15h2v2h-2zM11 8h2v5h-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsentPending);
export default __webpack_public_path__ + "static/media/consent_pending.86c7c3bf3e228ad4280d4177eca8789f.svg";
export { ForwardRef as ReactComponent };